import type { OffsetType } from '@/utils/hooks/format/formatCaptionText/types/OffsetType';

export function formatTextWithComponent(text: string, offsetList: OffsetType[], htmlTag?: string) {
    if (!offsetList?.length) {
        return formatParagraphs(text);
    }

    let addedOffset = 0;
    let textParts = text;

    offsetList.forEach((offset, id) => {
        const adaptedOffset = offset.offset + addedOffset;
        const beforeTag = textParts.slice(0, adaptedOffset);
        const afterTag = textParts.slice(adaptedOffset + offset.length);

        const component = `<${htmlTag ?? id}>${offset.name}</${htmlTag ?? id}>`;
        const addedLength = component.length - offset.name.length;
        addedOffset += addedLength;

        textParts = `${beforeTag}${component}${afterTag}`;
    });

    return formatParagraphs(textParts);
}

function formatParagraphs(text: string) {
    return text
        .split('\n')
        .map((paragraph) => (paragraph.length ? `<p>${paragraph}</p><br/>` : '<br/>'))
        .join('')
        .replace(/\n/g, '<br/>');
}
